import React from 'react';

import type { Props as SelectProps } from 'Elements/Input/Select';

import Grid, { Col } from 'Components/Grid';
import ArrowLink, { ArrowLinkProps } from 'Elements/Link/Arrow';

import {
    Wrapper,
    Container,
    SelectWrapper,
    SelectContainer,
    Label,
    YearSelect,
    SingleYear,
    VariantSelect,
    ClosedTab,
    ClearingTab
} from './CourseVariantSelector.styled';

export interface Props {
    yearLabel?: string;
    yearSelect?: SelectProps;
    variantLabel?: string;
    variantSelect?: SelectProps;
    showYearSelector?: boolean;
    showVariantSelector?: boolean;
    registerInterestLink?: ArrowLinkProps;
    state?: 'full' | 'clearing' | 'open';
    backgroundColor?: React.CSSProperties['color'];
}

const CourseVariantSelector: React.FC<Props> = props => {
    const {
        state,
        yearLabel = 'Starting in',
        yearSelect,
        variantLabel = 'Course length',
        variantSelect,
        backgroundColor,
        showYearSelector = true,
        showVariantSelector = true,
        registerInterestLink
    } = props;

    return (
        <Wrapper
            style={
                {
                    '--bg-color': backgroundColor
                } as React.CSSProperties
            }
        >
            {state === 'full' && (
                <ClosedTab>
                    <span>Course is currently closed</span>
                </ClosedTab>
            )}
            {state === 'clearing' && (
                <ClearingTab>
                    <span>Available through clearing</span>
                </ClearingTab>
            )}
            <Grid>
                <Col>
                    <Container>
                        <SelectWrapper>
                            {showYearSelector && yearSelect && (
                                <>
                                    {yearSelect.options.length > 1 ? (
                                        <SelectContainer>
                                            {yearSelect.options.length > 0 && (
                                                <>
                                                    <Label htmlFor={yearSelect.id}>
                                                        {yearLabel}:
                                                    </Label>
                                                    <YearSelect
                                                        {...yearSelect}
                                                        aria-labelledby={yearSelect.id}
                                                    />
                                                </>
                                            )}
                                        </SelectContainer>
                                    ) : (
                                        <SingleYear>
                                            {yearLabel}:&nbsp;
                                            <strong>{yearSelect.options[0].label}</strong>
                                        </SingleYear>
                                    )}
                                </>
                            )}
                            {showVariantSelector && variantSelect && (
                                <SelectContainer>
                                    {variantSelect.options.length > 1 && (
                                        <>
                                            <Label htmlFor={variantSelect.id}>
                                                {variantLabel}:
                                            </Label>
                                            <VariantSelect
                                                {...variantSelect}
                                                aria-labelledby={variantSelect.id}
                                            />
                                        </>
                                    )}
                                </SelectContainer>
                            )}
                        </SelectWrapper>
                        {registerInterestLink && <ArrowLink {...registerInterestLink} />}
                    </Container>
                </Col>
            </Grid>
        </Wrapper>
    );
};

export default CourseVariantSelector;
